@if (showTagLinkModal) {
<div class="modal-overlay" (click)="closeTagLinkModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <fa-icon [icon]="faTag"></fa-icon>
        <span>{{ (maxTags > 1 ? 'MODAL.MANAGE.TAG.TITLE' : 'MODAL.LINK.TAG.TITLE') | translate }}</span>
      </h3>
      <button class="close-btn" (click)="closeTagLinkModal()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="item-info-compact">
        <strong>{{ entityName }}:</strong>
        <span class="item-name">{{ selectedItem?.name }}</span>
        @if (maxTags > 1) {
        <span class="tags-counter">{{ selectedTags.length }}/{{ maxTags }}</span>
        }
      </div>
      <div class="search-container">
        <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
        <input type="text" [(ngModel)]="tagSearchTerm" [placeholder]="'MODAL.LINK.TAG.SEARCH_PLACEHOLDER' | translate"
          class="search-input" (input)="filterTags()" autoFocus>
      </div>

      <div class="tags-list-container">
        @if (loadingTags) {
        <div class="loading-state">
          <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
          <span>{{ 'MODAL.LINK.TAG.LOADING_TAGS' | translate }}</span>
        </div>
        } @else if (filteredTags.length === 0) {
        <div class="empty-state">
          <fa-icon [icon]="faTag"></fa-icon>
          <p>{{ 'MODAL.LINK.TAG.NO_TAGS' | translate }}</p>
        </div>
        } @else {
        <div class="tags-grid">
          @for (tag of filteredTags; track tag) {
          <div class="tag-card" (click)="selectTag(tag)" [class.selected]="isSelected(tag)"
            [style.border-color]="isSelected(tag) ? tag.text_color : 'transparent'">
            <div class="tag-badge" [style.background-color]="tag.bg_color" [style.color]="tag.text_color">
              {{ tag.name }}
            </div>
            @if (isSelected(tag)) {
            <div class="check-icon" [style.color]="tag.bg_color">
              <fa-icon [icon]="faCheck"></fa-icon>
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <div class="form-actions">
        <button type="button" class="cancel-button" (click)="closeTagLinkModal()">
          {{ 'BUTTON.CANCEL.GENERAL' | translate }}
        </button>
        <button type="button" class="save-button" (click)="confirmLinkTag()"
          [disabled]="(maxTags > 1 ? false : !selectedTag) || linkingTag">
          @if (linkingTag) {
          <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
          } @else {
          <fa-icon [icon]="faCheck"></fa-icon>
          }
          @if (maxTags > 1) {
          {{ linkingTag ? ('BUTTON.SAVING' | translate) : ('BUTTON.SAVE' | translate) }}
          } @else {
          {{ linkingTag ? ('BUTTON.LINKING' | translate) : ('BUTTON.LINK' | translate) }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
}

@if (showTagUnlinkModal) {
<div class="modal-overlay" (click)="closeTagUnlinkModal()">
  <div class="modal-content small" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <fa-icon [icon]="faUnlink"></fa-icon>
        <span>{{ 'MODAL.UNLINK.TAG.TITLE' | translate }}</span>
      </h3>
      <button class="close-btn" (click)="closeTagUnlinkModal()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="item-info-compact">
        <strong>{{ entityName }}:</strong>
        <span class="item-name">{{ selectedItem?.name }}</span>
      </div>

      @if (selectedItem?.tag) {
      <div class="current-tag-display">
        <h4>{{ 'MODAL.UNLINK.TAG.CURRENT_TAG' | translate }}</h4>
        <div class="tag-badge large" [style.background-color]="selectedItem?.tag?.bg_color"
          [style.color]="selectedItem?.tag?.text_color">
          {{ selectedItem?.tag?.name }}
        </div>
      </div>
      } @else {
      <div class="empty-state">
        <p>{{ 'MODAL.UNLINK.TAG.NO_TAG_LINKED' | translate }}</p>
      </div>
      }
    </div>
    <div class="modal-footer">
      <div class="form-actions">
        <button type="button" class="cancel-button" (click)="closeTagUnlinkModal()">
          {{ 'BUTTON.CANCEL.GENERAL' | translate }}
        </button>
        <button type="button" class="save-button" (click)="confirmUnlinkTag()"
          [disabled]="!selectedItem?.tag || unlinkingTag">
          @if (unlinkingTag) {
          <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
          } @else {
          <fa-icon [icon]="faUnlink"></fa-icon>
          }
          {{ unlinkingTag ? ('BUTTON.UNLINKING' | translate) : ('BUTTON.UNLINK' | translate) }}
        </button>
      </div>
    </div>
  </div>
</div>
}

<app-modal-tag-details [show]="showTagDescriptionModal" [tag]="selectedTag" (close)="closeTagDescriptionModal()">
</app-modal-tag-details>